class SystemMessage {
  topic = '';

  message = '';

  buttonLabel = '';

  buttonLink = '';

  icon = '';

  persistent = false;

  constructor(topic, message, buttonLabel, buttonLink, icon, persistent = false) {
    this.topic = topic;
    this.message = message;
    this.persistent = persistent;
    this.buttonLabel = buttonLabel;
    this.buttonLink = buttonLink;
    this.icon = icon;
  }
}

export default SystemMessage;
